import { useEffect, useState } from "react";
import { AnswerState } from "../../game-state/game-state.slice";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { playSound, retrieveUrl } from "../../game-state/games.functions";
import { useNavigate } from "react-router-dom";

function randomIntFromInterval(min: number, max: number) {
  // min and max included
  return Math.floor(Math.random() * (max - min + 1) + min);
}

export const EndScreen = (props: { answerState: AnswerState }) => {
  const [imageId] = useState(randomIntFromInterval(1, 6));
  const [icon, setIcon] = useState("");
  const storage = useAppSelector((state) => state.storageState);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const diff = props.answerState.total - props.answerState.correct;
  const resolvedUrl =
    storage[`finished/${diff <= 2 ? "finished" : "fail"}${imageId}.gif`];

  useEffect(() => {
    if (diff === 0) {
      setIcon("fa fa-trophy text-white");
    } else if (diff >= 1 && diff <= 2) {
      setIcon("fas fa-medal text-white");
    } else {
      setIcon("fa fa-poo text-yellow-700");
    }
  }, [diff, dispatch, setIcon]);

  useEffect(() => {
    if (diff <= 2) {
      dispatch(retrieveUrl(`finished/finished${imageId}.gif`));
      dispatch(playSound("sfx/cheer.mp3"));
    } else {
      dispatch(retrieveUrl(`finished/fail${imageId}.gif`));
    }
  }, [imageId, diff, dispatch]);

  return (
    <div className="py-8">
      <div className="flex justify-center items-center text-white mb-8">
        <div className="bg-yellow-400 shadow-md rounded-2xl border-white border-4">
          <i className={`fa ${icon} fa-3x p-4`} />
        </div>
        <button
          onClick={() => navigate("/")}
          className="btn-primary shadow-md w-48 h-full ml-6"
        >
          <i className="fa fa-sign-in-alt mr-2 fa-2x" />
          <span>Doorgaan</span>
        </button>
      </div>
      <div className="flex justify-center">
        <div className="px-2">
          <img
            className="border-8 p-4 bg-yellow-400 border-white rounded"
            src={resolvedUrl}
            alt={"finished"}
          />
        </div>
      </div>
    </div>
  );
};
